import { useTranslation } from "../i18n";

import { BrandLogo } from "./brand/BrandLogo";
import { footerShell, pageContainer } from "./ui";

export function Footer() {
	const { t, localizedPath } = useTranslation();

	return (
		<footer className={footerShell}>
			<div className={pageContainer}>
				<div className="flex flex-col items-center justify-between gap-4 sm:flex-row sm:gap-6">
					<div className="flex flex-col items-center gap-2 sm:items-start">
						<BrandLogo />
						<p className="text-xs text-muted-foreground">{t("footer.tagline")}</p>
					</div>
					<div className="flex flex-col items-center gap-4 sm:flex-row sm:gap-6">
						<nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-muted-foreground">
							<a href={localizedPath("/about")} className="transition-colors hover:text-foreground">
								{t("footer.about")}
							</a>
							<a href={localizedPath("/terms")} className="transition-colors hover:text-foreground">
								{t("footer.terms")}
							</a>
							<a href={localizedPath("/privacy")} className="transition-colors hover:text-foreground">
								{t("footer.privacy")}
							</a>
							<a href={localizedPath("/contact")} className="transition-colors hover:text-foreground">
								{t("footer.contact")}
							</a>
						</nav>
					</div>
				</div>
			</div>
		</footer>
	);
}
